import './styles/global.scss';
import './styles/index.scss';
import './styles/theme.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import App from './App';
import './i18n';
import { registerServiceWorker } from './lib/register-sw';
import ThemeProvider from './providers/theme/theme.provider';
import { store } from './store';

const rootEl = document.getElementById('root');
if (rootEl) {
  const helmetContext = {};

  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <ThemeProvider>
          <HelmetProvider context={helmetContext}>
            <Helmet titleTemplate="Company / %s" defaultTitle="Company" />
            <App />
          </HelmetProvider>
        </ThemeProvider>
      </Provider>
    </React.StrictMode>
  );

  registerServiceWorker();
}
